"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24ViewCollapse = function Svg24ViewCollapse(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 14h-1.446c-.238 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 0 0-1.311 1.311 3.015 3.015 0 0 0-.307 1.142c-.02.251-.02.535-.02.774V19h2v-1.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C16.76 16 17.04 16 17.6 16H19v-2zM5 16v-2h1.446c.239 0 .523 0 .774.02.29.024.706.085 1.142.307a3 3 0 0 1 1.311 1.311c.222.436.283.852.307 1.142.02.251.02.535.02.774V19H8v-1.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 16 6.96 16 6.4 16H5zm0-8h1.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4V5h2v1.446c0 .239 0 .523-.02.774-.024.29-.085.706-.307 1.142a3 3 0 0 1-1.311 1.311 3.015 3.015 0 0 1-1.142.307c-.251.02-.535.02-.774.02H5V8zm11-3v1.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 8 17.04 8 17.6 8H19v2h-1.446c-.238 0-.523 0-.774-.02a3.015 3.015 0 0 1-1.142-.307 3 3 0 0 1-1.311-1.311 3.015 3.015 0 0 1-.307-1.142C14 6.969 14 6.685 14 6.446V5h2z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24ViewCollapse.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24ViewCollapse;
exports.default = _default;